"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyListItem = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.EmptyListItem = (0, styled_1.default)('li') `
  border: 2px dashed ${(0, ui_theme_1.fromTheme)('color_border')};
`;
//# sourceMappingURL=EmptyElements.styles.js.map